/* eslint-disable no-undef */
import React from 'react';
import { Redirect } from 'react-router-dom';
import Stopper from '@bitComponents/unifiedComponents/Stopper';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';
import ErrorScreen from './Screens/Error';

/**
 * Componente statefull que crea el ErrorBoundary
 * @param {string} error Error atrapado
 * @param {string} errorInfo Detalles del error que renderiza la pagina
 * @returns {JSX} Componente JSX.
 */

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    const { contextData } = props;
    this.state = {
      errorInfo: null,
      redirect: null,
      contextData,
    };
  }

  /**
   * Crea una subscripcion para escuchar los cambios del history
   */
  componentDidMount = () => {
    const { history } = this.props;
    history.listen((location) => {
      const { errorInfo } = this.state;
      if (errorInfo) {
        this.setState({ redirect: location });
      }
    });
  };

  /**
   * Elimina la subscripcion del history al desmontarse el componente
   */
  componentWillUnmount = () => {
    const { history } = this.props;
    if (history) {
      try {
        history.removeEventListener('listen');
      } catch (err) {
        // console.log(`err: ${err}`);
      }
    }
  };

  /**
   * Crea y envia el sondado con el error capturado
   * @param {error} error Error producion
   * @return {undefined}
   */
  sendSondaInfo = (error) => {
    const { contextData } = this.state;
    const frontSonda = new FrontSonda({
      processName: 'ErrorBoundary',
      context: contextData,
      filePath: 'AppController',
    });

    frontSonda.fatalMessage({ error });
  };

  /**
   * Enviar el error que atrapa el errorBoundary
   * @param {error} error Error atrapado
   * @return {undefined}
   */
  componentDidCatch = (error) => {
    this.setState({ errorInfo: error });
    this.sendSondaInfo(error);
  };

  render() {
    if (this.state.redirect && this.state.errorInfo) {
      this.setState({ redirect: null, errorInfo: null });
      return <Redirect to={this.state.redirect} />;
    }

    if (!this.state.errorInfo) {
      /* Normally, just render children, all APP */
      return this.props.children;
    }
    const { defaultErrorScreen, projectId } = this.props;
    if (defaultErrorScreen) {
      return <Stopper {...defaultErrorScreen} projectId={projectId} />;
    }
    return <ErrorScreen />;
  }
}

export default ErrorBoundary;
